import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional 
const firebaseConfig = { 
  apiKey: "AIzaSyB2aQY1Ue1MMlUeu62mEGzowtAZot3v_HM", 
  authDomain: "devine-stone.firebaseapp.com", 
  projectId: "devine-stone", 
  storageBucket: "devine-stone.firebasestorage.app", 
  messagingSenderId: "565122622281", 
  appId: "1:565122622281:web:0e0c5588fcf9b14bd5f098", 
  measurementId: "G-MFPFEBHTND" 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firestore
export const db = getFirestore(app);

// Initialize and export Auth
export const auth = getAuth(app);